<template>
	<!-- 确认调整计划 -->
	<el-dialog title="确认节点完成" :close-on-click-modal="false" :visible.sync="visible" width="500px">
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="120px" :inline="true" class="border-form">
			<el-row class="set_border">
				<el-col :span="24" class="col-set_border">
					<el-form-item label="节点名称" prop="nodeName" class="item">
						<el-input class="selItemInput" v-model="dataForm.nodeName" :disabled="true" placeholder="节点名称"
							style="width:300px"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row class="set_border">
				<el-col :span="24" class="col-set_border">
					<el-form-item label="实际时间" prop="planTime" class="item">
						<el-date-picker class="selItemInput" value-format="yyyy-MM-dd" v-model="dataForm.actualTime"
							type="date" style="width:300px">
						</el-date-picker>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<el-row class="formBtnGroup">
			<el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
			<el-button v-preventReClick @click="visible = false" class="rebtn" size="small">取消</el-button>
		</el-row>
	</el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
	name: "nodeList-confirm",
	data() {
		return {
			//当前页码
			pageIndex: 1,
			//当前记录数
			pageSize: 5,
			nodeinfoList: [],
			visible: false,
			inline: false,
			activeNames: ['1'],
			dataForm: {
				//编号(调用保存的方法时)
				recNo: 0,
				//节点名称
				nodeName: '',
				//编号(调用保存的方法)
				nodeId: '',
				//实际时间
				actualTime: '',
			},
			dataRule: {},
		}
	},
	methods: {
		init(id) {
			// console.log(id,'id')
			this.dataForm.nodeId = id || 0;
			this.visible = true;
			this.$nextTick(() => {
				this.$refs['dataForm'].resetFields()
				if (this.dataForm.nodeId) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/nodeinfo/info/${this.dataForm.nodeId}`,
						method: 'get',
						params: this.$http.adornParams()
					}).then(({ data }) => {
						if (data && data.code === 200) {
							this.dataForm.nodeId = data.body.nodeId
							this.dataForm.nodeName = data.body.nodeName
						}
					})
				}
			})
		},
		// 表单提交
		dataFormSubmit() {
			this.$refs["dataForm"].validate(valid => {
				if (valid) {
					this.$http({
						url: this.$store.state.httpUrl + `/business/nodeinfo/updateByNodeName/`,
						method: "post",
						data: this.$http.adornData({
							workNo: $common.getItem("workNo"),
							nodeId: this.dataForm.nodeId,
							actualTime: this.dataForm.actualTime
						})
					}).then(({ data }) => {
						if (data && data.code === 200) {
							this.$message({
								message: "操作成功",
								type: "success",
								duration: 1500,
								onClose: () => {
									this.visible = false;
									this.$parent.getDataList();
								}
							});
						} else {
							this.$message.error(data.msg);
						}
					});
				}
			});
		},
	}
}
</script>
<style lang="scss" scoped>
.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.border-form .el-row.set_border {
	border-bottom: solid #dadada 1px;
	border-left: solid #dadada 1px;
	border-right: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}
</style>
